import { set, get, remove } from '../lib/storage/isomorphicLocalStorage'

// When changing the structure of local storage item change the key so that
// errors are not created on users browsers.
export const PENDING_PAYMENTS_ORDER_PREFIX = 'ppv001_'

export interface PaymentObject {
  order: App.Order
  paymentType: string
}

export function setPendingPayment(pendingPaymentObject: PaymentObject, orderId: string) {
  return set(PENDING_PAYMENTS_ORDER_PREFIX + orderId, pendingPaymentObject)
}

export function getPendingPayment(orderId: string) {
  return get(PENDING_PAYMENTS_ORDER_PREFIX + orderId) || null
}

export function clearPendingPayment(orderId: string) {
  return remove(PENDING_PAYMENTS_ORDER_PREFIX + orderId)
}
